import type { RemoteLaunchIntent } from '../../../api/generated/model'

export type PreparedRemoteTab = { name: string; popup: Window }

export function prepareRemoteTab(browserWindow: Window = window): PreparedRemoteTab | null {
  const name = `pexify-remote-${crypto.randomUUID()}`
  const popup = browserWindow.open('', name, 'noopener=false')
  if (!popup) return null

  popup.opener = null
  return { name, popup }
}

export function postLaunchTicket(tab: PreparedRemoteTab, intent: RemoteLaunchIntent): void {
  // The form lives in the popup's own document and submits itself. Targeting the
  // popup by window name from the opener does not survive `opener = null`: the
  // submission goes nowhere and the tab is left sitting on about:blank.
  const doc = tab.popup.document
  doc.open()
  doc.write('<!doctype html><meta charset="utf-8"><title>PEXIFY Remote Access</title>')
  doc.close()

  const form = doc.createElement('form')
  const ticket = doc.createElement('input')

  form.method = 'post'
  form.action = intent.launch_form_url
  form.hidden = true
  ticket.type = 'hidden'
  ticket.name = 'ticket'
  ticket.value = intent.launch_ticket
  form.append(ticket)
  doc.body.append(form)

  try {
    form.submit()
  } finally {
    ticket.value = ''
    form.remove()
  }
}

export function showRemoteTabFailure(tab: PreparedRemoteTab, message: string): void {
  const doc = tab.popup.document
  doc.open()
  doc.write('<!doctype html><meta charset="utf-8"><title>PEXIFY</title><main id="message"></main>')
  doc.close()

  const messageNode = doc.getElementById('message')
  if (messageNode) messageNode.textContent = message
}

export function closePreparedRemoteTab(tab: PreparedRemoteTab): void {
  tab.popup.close()
}
